






















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({ components: {} })
export default class Modal extends Vue {
    @Prop()
    public visible!: boolean;
    @Prop()
    public noClose!: boolean;
    
    onClose(){
        if(this.noClose) return;
        this.$emit('on-close');
    }
    @Watch('visible')
    public visibleCahnged() {
        document.body.style.overflow = this.visible ? 'hidden' : 'inherit';
    }
}
